import Uniforms from "./noise_offset_uniforms.glsl";
import Vertex from "./noise_offset_vertex.glsl";
import Noise from "./noise_simplex.glsl";
import { Uniform, Vector3 } from "three";

export default shader => {
  shader.uniforms.noiseOffset = new Uniform(new Vector3(0, 0, 0));
  shader.vertexShader = Uniforms + Noise + shader.vertexShader.replace("#include <begin_vertex>", Vertex);
};
